import RequestAbstract from "../abstract";

export default class PublicAppealDocuments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-appeal-documents';
    }

}
